import { meta } from "@/lib/statusMeta";
import { Check } from "lucide-react";

export function StatusTimeline({ steps, current, history = [] }) {
  const idx = steps.indexOf(current);
  const tsFor = (s) => {
    const h = [...history].reverse().find((x) => x.status === s);
    return h ? new Date(h.at).toLocaleDateString(undefined, { month: "short", day: "numeric" }) : null;
  };
  return (
    <div className="flex items-start justify-between gap-1" data-testid="order-status-timeline">
      {steps.map((s, i) => {
        const done = i < idx;
        const isCurrent = i === idx;
        const c = meta(s).color;
        return (
          <div key={s} className="flex-1 flex flex-col items-center text-center relative">
            {i > 0 && (
              <div className="absolute top-4 right-1/2 w-full h-0.5 -z-0"
                style={{ background: i <= idx ? c : "hsl(var(--border))" }} />
            )}
            <div className="relative z-10 w-8 h-8 rounded-full flex items-center justify-center border-2 transition-colors"
              style={{
                background: done || isCurrent ? c : "hsl(var(--card))",
                borderColor: done || isCurrent ? c : "hsl(var(--border))",
              }}>
              {done ? <Check className="w-4 h-4 text-primary-foreground" strokeWidth={3} />
                : <span className={`w-2 h-2 rounded-full ${isCurrent ? "bg-background animate-pulse" : "bg-muted-foreground"}`} />}
            </div>
            <div className={`mt-2 text-[11px] font-medium leading-tight ${isCurrent ? "text-foreground" : "text-muted-foreground"}`}>
              {meta(s).label}
            </div>
            <div className="mono text-[9px] text-muted-foreground mt-0.5">{tsFor(s) || "—"}</div>
          </div>
        );
      })}
    </div>
  );
}

export function StatusBadge({ status }) {
  const m = meta(status);
  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold"
      style={{ background: m.color + "22", color: m.color }} data-testid="status-badge">
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: m.color }} />
      {m.label}
    </span>
  );
}
